import React from "react";
import ReactDOM from 'react-dom/client';
import App from "./App";
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './store/store';
import reportWebVitals from "./reportWebVitals";
import  ThemeContext  from "./context/ThemeContext";

import '@rainbow-me/rainbowkit/styles.css';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import {connectorsForWallets, lightTheme, RainbowKitProvider} from '@rainbow-me/rainbowkit';
import {configureChains, createConfig, WagmiConfig} from 'wagmi';
import { publicProvider } from 'wagmi/providers/public';
import { mainnet, bsc } from './chain/chains';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {metaMaskWallet} from "@rainbow-me/rainbowkit/wallets";
import { trustWallet } from '@rainbow-me/rainbowkit/wallets';

dayjs.extend(utc);

const { chains, publicClient } = configureChains(
	[mainnet, bsc],
	[publicProvider()],
);
const connectors = connectorsForWallets([
	{
		groupName: 'Recommended',
		wallets: [
			metaMaskWallet({ chains, projectId: 'a634686cc6b6549aaaecb25b14d2fd25' }),
			trustWallet({ chains, projectId: 'a634686cc6b6549aaaecb25b14d2fd25' }),
		]
	}
]);
const wagmiConfig = createConfig({
	autoConnect: true,
	connectors,
	publicClient
});

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<WagmiConfig config={wagmiConfig}>
			<RainbowKitProvider
				locale="en"
				chains={chains}
				theme={lightTheme()}
			>
				<QueryClientProvider client={queryClient}>
					<Provider store = {store}>
						<BrowserRouter>
							<ThemeContext>
								<App />
							</ThemeContext>
						</BrowserRouter>
					</Provider>
				</QueryClientProvider>
			</RainbowKitProvider>
		</WagmiConfig>
	</React.StrictMode>
);
reportWebVitals();
